import { render, staticRenderFns } from "./StarMain.vue?vue&type=template&id=9e8dbf9c&scoped=true&"
import script from "./StarMain.vue?vue&type=script&lang=js&"
export * from "./StarMain.vue?vue&type=script&lang=js&"
import style0 from "./StarMain.vue?vue&type=style&index=0&id=9e8dbf9c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8dbf9c",
  null
  
)

export default component.exports